// Flags whose last online decision is replayed while the provider is unreachable.
// Admission bar, rationale and each key's offline limitation:
// docs/desktop/offline-flag-decision-cache.md
import {
  NEW_SESSION_LIST_FLAG_KEY,
  SESSION_LAYOUT_MANAGED_RELEASE_FLAG_KEY,
} from '@heidi/session/flags';

import { SESSION_PAGE_V2_FLAG_KEY } from './session-page-v2-flag';

// UNCARVED DOMAIN KEY (app-shell, DSK-748): not a cache identity at all — these are
// Flagsmith feature-flag keys, each minted once elsewhere, merely listed here. No
// queryKey, no mutationKey, and the localStorage key the decision cache derives is
// built in `offline-recording-flag-cache.ts` from the flag key plus its own prefix,
// not from this array. There is no /contracts door for a flag-key list, and flags are
// app-shell: `src/features/flags` is the single canonical surface for them.
// eslint-disable-next-line @heidi/rules/no-new-cache-key-declaration -- feature-flag keys listed for the offline decision cache, not a cache identity; each key is minted once elsewhere and nothing is keyed on this array
export const OFFLINE_CACHED_FLAG_KEYS = [
  NEW_SESSION_LIST_FLAG_KEY,
  SESSION_PAGE_V2_FLAG_KEY,
  SESSION_LAYOUT_MANAGED_RELEASE_FLAG_KEY,
] as const;

export type OfflineCachedFlagKey = (typeof OFFLINE_CACHED_FLAG_KEYS)[number];
